import { DescriptiveSelectOption } from 'tailwindComponents/selectTW/interfaces';
import { labelComparator } from '../../../utilities/labelComparator';

export interface IVestingResponse {
  id: string;
  label: string;
  description: string;
}

export const getVestingsOptions = (vestingReasons: IVestingResponse[]): DescriptiveSelectOption[] =>
  vestingReasons
    .map((vesting) => ({
      label: vesting.label,
      value: vesting.id,
      description: vesting.description,
    }))
    .toSorted(labelComparator);
